import React from "react";
import { Link } from "react-router-dom";
const Breadcrumbs = ({ routes }) => {
  // Don't render a single breadcrumb.
  if (routes.length <= 1) {
    return null;
  }
  return (
    <div>
      {/* Link back to any previous steps of the breadcrumb. */}
      {routes.map(({ name, path }, key) =>
        key + 1 === routes.length ? (
          <span key={key}>
            {name}
          </span>
        ) : (
          <Link key={key} to={path}>
            {name}
          </Link>
        )
      )}
    </div>
  );
};
export default Breadcrumbs;